var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useUser } from "./Permission";
import { orange } from "@mui/material/colors";
import { useProjectId } from "../pages/project/shopdrawing/ProjectName";
import { useIsQuote } from "../pages/project/quote/QuoteContainer";
import { api } from "../api/API";
import { useContext } from "react";
import { ConfirmContext } from "./Confirm";
import { useSnackbar } from "./Snackbar";
import { useNavigate } from "react-router-dom";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TestingBanner() { const u = useUser(); if (!u)
    return null; if (u.isProductionEnv)
    return null; return /*#__PURE__*/ _jsxs("div", { style: { width: "100%", padding: 4, textAlign: "center", backgroundColor: orange["800"], color: "white" }, children: ["This is a testing environment", /*#__PURE__*/ _jsx(ResetProjectToQuoteMode, {})] }); }
function ResetProjectToQuoteMode() { const projectId = useProjectId(); const isQuote = useIsQuote(); const confirm = useContext(ConfirmContext); const snack = useSnackbar(); const nav = useNavigate(); if (projectId === 0)
    return null; if (isQuote)
    return null; return /*#__PURE__*/ _jsx("button", { style: { marginLeft: 12 }, onClick: () => __awaiter(this, void 0, void 0, function* () { const ok = yield confirm.confirm("Are you sure you want to reset this project to quote mode?"); if (!ok)
        return; try {
        snack.loading();
        yield api.projects.resetToQuoteMode({ project: projectId });
        snack.success("Project reset to quote mode");
        nav(`/project/${projectId}`);
    }
    catch (e) {
        snack.error(e.toString());
    } }), children: "*Reset Project to Quote Mode*" }); }
